(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      const container = btn.closest('.details-content');
      if (!container) return;
      const modal = container.querySelector('[data-size-guide-modal]');
      if (!modal) return;

      // Move modal to body so it escapes all stacking contexts
      document.body.appendChild(modal);

      btn.addEventListener('click', function () {
        modal.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        modal.querySelector('[data-size-guide-close]')?.focus();
      });

      modal.querySelectorAll('[data-size-guide-close]').forEach(function (closer) {
        closer.addEventListener('click', function () {
          modal.setAttribute('hidden', '');
          document.body.style.overflow = '';
          btn.focus();
        });
      });

      modal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          modal.setAttribute('hidden', '');
          document.body.style.overflow = '';
          btn.focus();
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
